<template>
  <div class="contain">
    <div class="posting-uploader">
      <div
          class="posting-uploader-item"
          v-for="(item, index) in postData"
          :key="index"
      >
        <van-tag plain round closeable @close="remove(index)">{{ item.name }}</van-tag>
      </div>
      <van-uploader
          :accept="accept"
          :after-read="uploadFile"
          upload-icon="column"
          v-show=" postData.length < limit"
          result-type="text"
          :upload-text="uploadText"
      >
      </van-uploader>
    </div>
    <van-popup v-model="showLoading">
      <van-loading type="spinner" color="#1989fa"/>
    </van-popup>
  </div>
</template>

<script>
import OSS from 'ali-oss';
import {Uploader, Toast, Loading, Tag} from 'vant';
import Vue from 'vue';
import XLSX from "xlsx";

Vue.use(Uploader).use(Toast).use(Loading).use(Tag);

export default {
  props: {
    fileList: Array,
    accept: {
      type: String,
      default: '.jpg,.png,.gif,.jpeg,.doc,.pdf,.ppt,.docx,.xls,.xlsx,.pptx,.rar,.zip',
    },
    limit: {
      type: Number,
      default: 0,
    },
    name: {
      type: String,
      default: ''
    },
    uploadText: {
      type: String,
      default: '上传音乐',
    },

    startNum: {
      type: Number,
      default: 0,
    }

  },
  data() {
    return {
      postData: [],
      uid: 0,
      showLoading: false,
      ossAccessTokenURL: 'https://bc-api.ccachina.net/core/attachment/aliOssSts',
      ossFileURL: 'https://bc2026.oss-ap-southeast-1.aliyuncs.com',
    }
  },
  mounted() {
    this.postData = this.fileList
  },
  watch: {
    fileList(value) {
      this.postData = value
    }
  },
  methods: {

    remove(index) {
      // 删除指定下标的图片对象
      let that = this;
      if (isNaN(index) || index >= that.postData.length) {
        return false
      }

      this.postData.splice(index, 1)
      this.$emit('fileListChange', {'pic': that.postData, 'name': that.name})
    },

    uploadFile(evt) {
      console.log('------uploadFile------')
      let that = this;
      that.showLoading = true;
      OSS.urllib.request(that.ossAccessTokenURL, {method: 'GET'}, function (err, response) {
        let result;
        if (err) {
          Toast.fail('上传异常:' + err);
          console && console.error(err);
          return;
        }

        try {
          result = JSON.parse(response);
        } catch (e) {
          return alert('parse sts response info error: ' + e.message);
        }

        var client = new OSS({
          accessKeyId: result.data.AccessKeyId,
          accessKeySecret: result.data.AccessKeySecret,
          stsToken: result.data.SecurityToken,
          endpoint: result.data.endpoint,
          bucket: result.data.bucket,
          secure: true
        });

        var suffix = evt.file.name.toLowerCase().split('.').splice(-1)[0];

        var myDate = new Date().getTime();
        let time = myDate + '' + (Math.floor(Math.random() * 1000 + 1));
        let date = that.dateFormat(myDate);

        var file_save_name = 'h5/' + date + '/' + time + '.' + suffix;
        client.multipartUpload(file_save_name, evt.file).then(function (result) {
          console.log(that.ossFileURL);
          var file = {
            uid: 'vc-upload-'+time,
            url: that.ossFileURL + '/' + file_save_name,
            name: evt.file.name,
            save_name: file_save_name
          }
          that.postData.push(file);

          that.showLoading = false;

          that.readFile(evt.file)
          // Toast.success(evt.file.name + '上传成功');
          that.$emit('fileListChange', {'pic': that.postData, 'name': that.name})
        }).catch(function (err) {
          // Toast.fail(evt.file.name + '上传失败');
        })

      })
    },

    readFile(file) {
      console.log('------readFile------', file)
      var that = this;
      let files = {0: file}
      // if (files.length <= 0) {//如果没有文件名
      //   return false;
      // } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
      //   Toast('上传格式不正确，请上传xls或者xlsx格式');
      //   return false;
      // }

      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: 'binary'
          });
          const wsname = workbook.SheetNames[0];//取第一张表
          var list = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]);//生成json表格内容

          if(that.startNum) {
            list = list.splice(that.startNum, list.length)
          }

          let listData = list.filter(row => {
            return row.hasOwnProperty("__EMPTY");
          })
          console.log(listData)

          // 最终数据
          that.$emit('onGetData', listData)

        } catch (e) {
          console.log(e)
          return false;
        }
      };
      fileReader.readAsBinaryString(files[0]);
    },

  }
}
</script>

<style scoped>
.contain >>> .van-popup {
  background: none;
}

.posting-uploader {
  display: flex;
  flex-wrap: wrap;
}

.posting-uploader-item {
  position: relative;
  margin: 0 8px 8px 0;
}

.imgPreview {
  /*display: block;*/
  width: 80px;
  height: 80px;
}

.delte {
  /*margin-left: -15px;
  width: 10px;
  height: 10px;
  margin-right: 20px;*/
  position: absolute;
  right: 0;
  top: 0;
  padding: 1px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.45);
}

.upload-img-5 {
  margin: 5px 0 90px 0;
}

.upload-img-1 {
  margin: 5px 0 15px 0;
}
</style>



// WEBPACK FOOTER //
// FileUploaderData.vue?1d093eea